import React, { useState, useEffect } from 'react'
import MaterialTable from 'material-table'
import { TextField, Button, Select, MenuItem, Grid, Snackbar } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import DateFnsUtils from '@date-io/date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers'
import {
  getGas,
  getEnsambladoras,
  postGas,
  getPermisosByUser,
  getTipos,
  deleteGas
} from '@auteco/services/sostenibilidadService'

import './SostenibilidadGasContainer.css'


const SostenibilidadGasContainer = () => {
  const [data, setData] = useState([])
  const [fechaInicial, setFechaInicial] = useState(null)
  const [fechaFinal, setFechaFinal] = useState(null)
  const [m3, setM3] = useState(200)
  const [costoM3, setCostoM3] = useState(200)
  const [empresa, setEmpresa] = useState('')
  const [sede, setSede] = useState('')
  const [contrato, setContrato] = useState('')
  const [empresasList, setEmpresasList] = useState([])
  const [sedesList, setSedesList] = useState([])
  const [contratosList, setContratosList] = useState([])
  const [permisos, setPermisos] = useState(0)
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'success'
  })

  const columns = [
    {
      title: 'Empresa',
      field: 'ensambladora_id',
      render: (rowData) => {
        const empresaFind = empresasList.find(
          (emp) => emp.id === rowData.ensambladora_id,
        )
        return empresaFind ? empresaFind.nombre : 'Desconocida'
      },
    },
    {
      title: 'Sede',
      field: 'ensambladora_id',
      render: (rowData) => {
        const ensambl = empresasList.find(
          (emp) => emp.id === rowData.ensambladora_id,
        )
        if(ensambl && ensambl.sedes && ensambl.sedes.length > 0){
        const sedeT = ensambl.sedes.find((sedeTT) =>parseInt(sedeTT.id, 10) === parseInt(rowData.sede_id, 10))
        return sedeT ? sedeT.nombre  : 'Desconocida'
        }
          return 'Desconocida s'
        
      },
    },
    { title: 'Fecha Inicial', field: 'fecha_inicial', type: 'date' },
    { title: 'Fecha Final', field: 'fecha_final', type: 'date' },
    { title: 'M3', field: 'm3', type: 'numeric' },
    { title: 'Costo/M3', field: 'costo_m3', type: 'numeric' },
    {
      title: 'Contrato',
      field: 'contrato_id',
      render: rowData => {
        const contratoFind = contratosList.find(c => c.id === rowData.contrato_id);
        return contratoFind ? contratoFind.nombre : 'Desconocido';
      }
    },
  ]

  const handleGetGas = async () => {
    const response = await getGas()
    if (response) {
      setData(response.gas)
    }
  }

  const handleGetEmpresas = async () => {
    const { ensambladoras } = await getEnsambladoras()
    if (ensambladoras) {
      setEmpresasList(ensambladoras)
    }
  }

  const handleAdd = async () => {
    const newEntry = {
      ensambladoraId: parseInt(empresa, 10),
      sedeId: parseInt(sede, 10),
      fechaInicial: fechaInicial.toISOString().split('T')[0],
      fechaFinal: fechaFinal.toISOString().split('T')[0],
      m3: parseInt(m3, 10),
      costoM3: parseFloat(costoM3),
      contratoId: parseInt(contrato, 10),
    }

    const response = await postGas(newEntry)
    if (response) {
      handleGetGas()
    }
  }

  const handleGetPermisosByUser = async () => {
    const response = await getPermisosByUser()
    if (response) {
      const gasPermiso = response.permisos.find(permiso => permiso.nombre === 'Gas');
      if (gasPermiso) {
        setPermisos(parseInt(gasPermiso.alcance, 10))
      }
    }
  }

  const handleEmpresaChange = (e) => {
    const selectedEmpresaId = e.target.value
    setEmpresa(selectedEmpresaId)
    
    const selectedEmpresa = empresasList.find(emp => emp.id === selectedEmpresaId)
    if (selectedEmpresa && selectedEmpresa.sedes) {
      setSedesList(selectedEmpresa.sedes)
    } else {
      setSedesList([])
    }
    
    setSede('')
  }

  const handleGetTipos = async () => {
    const response = await getTipos()
    setContratosList(response.tipos.filter((item) => item.tipo_id === '6'))
  }

  const handleDeleteGas = async (id) => {
    try {
      const response = await deleteGas(id)
      console.log(response)
      if (response.data && response.data.success) {
        setNotification({
          open: true,
          message: 'Registro eliminado correctamente',
          severity: 'success'
        })
        await handleGetGas()
      } else {
        setNotification({
          open: true,
          message: 'Error al eliminar el registro',
          severity: 'error'
        })
      }
    } catch (err) {
      console.error('Error al eliminar:', err)
      setNotification({
        open: true,
        message: 'Error al eliminar el registro',
        severity: 'error'
      })
    }
  }

  const handleCloseNotification = () => {
    setNotification({ ...notification, open: false })
  }

  useEffect(() => {
    handleGetGas()
    handleGetEmpresas()
    handleGetPermisosByUser()
    handleGetTipos()

  }, [])

  if(permisos === 0){
    return (
      <div>
        <p>Permisos insuficientes</p>
      </div>
    )
  }

  return (
    <div>
      {permisos > 0 && (
        <MaterialTable
          title="Consumo de Gas"
          columns={columns}
          data={data}
          options={{
            headerStyle: {
              backgroundColor: '#f1f1f1',
              color: 'black',
              fontWeight: 'bold',
            },
          }}
          actions={[
            {
              icon: 'delete',
              tooltip: 'Eliminar',
              onClick: (event, rowData) => handleDeleteGas(rowData.id)
            },
          ]}
        />
      )}
      {permisos > 1 && (
        <div className="container_baterias_form">
          <h3>Registro Gas</h3>
          <Grid
            container
            spacing={2}
            style={{ marginTop: '20px', maxWidth: '800px' }}
          >
            <Grid item xs={6}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  id="fechaInicial"
                  label="Fecha Inicial"
                  format="dd/MM/yyyy"
                  value={fechaInicial}
                  onChange={setFechaInicial}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  fullWidth
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={6}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  id="fechaFinal"
                  label="Fecha Final"
                  format="dd/MM/yyyy"
                  value={fechaFinal}
                  onChange={setFechaFinal}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  fullWidth
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="M3"
                type="number"
                value={m3}
                onChange={(e) => setM3(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="COSTO M3"
                type="number"
                value={costoM3}
                onChange={(e) => setCostoM3(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <Select
                value={empresa}
                onChange={handleEmpresaChange}
                displayEmpty
                fullWidth
              >
                <MenuItem value="" disabled>
                  Empresa
                </MenuItem>
                {empresasList.map((emp) => (
                  <MenuItem key={emp.id} value={emp.id}>
                    {emp.nombre}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={6}>
              <Select
                value={sede}
                onChange={(e) => setSede(e.target.value)}
                displayEmpty
                fullWidth
                disabled={!empresa}
              >
                <MenuItem value="" disabled>
                  Sede
                </MenuItem>
                {sedesList.map((s) => (
                  <MenuItem key={s.id} value={s.id}>
                    {s.nombre}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={6}>
              <Select
                value={contrato}
                onChange={(e) => setContrato(e.target.value)}
                displayEmpty
                fullWidth
              >
                <MenuItem value="">Contrato</MenuItem>
                {contratosList &&
                  contratosList.map((tipo) => (
                    <MenuItem key={tipo.id} value={tipo.id}>
                      {tipo.nombre}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            <Grid item xs={8}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleAdd}
                style={{ width: '300px' }}
                disabled={
                  !fechaInicial ||
                  !fechaFinal ||
                  !m3 ||
                  !costoM3 ||
                  !empresa ||
                  !sede ||
                  !contrato
                }
              >
                Agregar
              </Button>
            </Grid>
          </Grid>
        </div>
      )}
      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseNotification} severity={notification.severity}>
          {notification.message}
        </Alert>
      </Snackbar>
    </div>
  )
}

export default SostenibilidadGasContainer